import { RecipeDetailResponse } from '@diamond/shared/types';

export type RecommendedProduct =
  RecipeDetailResponse['ingredient_groups'][number]['ingredients'][number]['recommended_products'];
export type AlternatifProduct =
  RecipeDetailResponse['ingredient_groups'][number]['ingredients'][number]['alternative_products'];

export function handleCogSummary(
  data: RecommendedProduct | AlternatifProduct,
  isSum: boolean
) {
  if (isSum) {
    const cogSummary = data
      .map((reko) => reko.cogs_per_portion)
      .reduce((acc, cur) => acc + cur, 0);

    return cogSummary;
  }

  const cogSummary = data.map((reko) => reko.cogs_per_portion).length;

  return cogSummary;
}
